export function pickLegalHtml(item, locale) {
    if (!item) {
        return '';
    }

    const isSpanish = String(locale || 'es').toLowerCase().startsWith('es');
    if (isSpanish) {
        return item.text_es || item.Text_es || item.text_en || item.Text_en || '';
    }

    return item.text_en || item.Text_en || item.text_es || item.Text_es || '';
}
